// Angular imports
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

//local imports
import { TenantModel } from '@core/data';

@Component({
  selector: 'tenant-picker-item',
  standalone: false,
  templateUrl: './tenant-picker-item.component.html',
  styleUrl: './tenant-picker-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TenantPickerItemComponent {
  @Input() public tenant: TenantModel;
  @Input() public isCurrentTenant = false;

  @Output() public selected = new EventEmitter<TenantModel>();

  public onSelect(): void {
    if (!this.tenant || this.isCurrentTenant) {
      return;
    }

    this.selected.emit(this.tenant);
  }
}
